import { render, staticRenderFns } from "./videoCon.vue?vue&type=template&id=487b2dca&scoped=true&"
import script from "./videoCon.vue?vue&type=script&lang=js&"
export * from "./videoCon.vue?vue&type=script&lang=js&"
import style0 from "./videoCon.vue?vue&type=style&index=0&id=487b2dca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b2dca",
  null
  
)

export default component.exports